import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/glances.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Glances extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 885 644' />
  }
}
